module.exports = __webpack_public_path__ + "assets/img/logo.c5ec65ff.png";